import Badge from "theme/components/badges/Badge";
import styled from "theme/libs/styled";

const BlueBadge = styled(Badge)`
    background-color: ${({ theme }) => `${theme.colors.blue_200}`};
    color: ${({ theme }) => `${theme.colors.black}`};
`;

export default BlueBadge;
